// extracted by mini-css-extract-plugin
export default {"checkbox-wrapper-54":"DarkMode_checkbox-wrapper-54__Ru80j","switch":"DarkMode_switch__qOPCj","slider":"DarkMode_slider__lCbkt"};